import { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseSupplierProduct } from "./UseSupplierProduct";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import {
  capitalizeFirstLetter,
  deCapitalizeFirstLetter,
} from "../../util/Utils";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteRow from "../../components/DeleteRow";
import SearchComOff from "../../ContentManagement/firstPage/HomeOffer/SearchComOff";
import { useSnackbar } from "notistack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";

export default function SupplierProduct(props) {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const navigate = useNavigate();
  const { getSupplierProductsByID, addSupplierProduct, deleteSupplierProduct } =
    UseSupplierProduct();
  const [myPcNew, setMyPcNew] = useState({
    page: 0,
    sortColumn: "Id",
    sortOrder: "Asc",
    forceRefresh: false,
  });

  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState("");
  const [supplierProductRes, setSupplierProductRes] = useState();
  const [addProduct, setAddProduct] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    supplierID: props.SupplierID,
    productID: "",
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const refresh = () => {
    let page = myPcNew.page;
    if (page === 0) {
      page = 1;
    }
    setMyPcNew({ ...myPcNew, forceRefresh: !myPcNew.forceRefresh, page: page });
  };

  const updatePage = (page) => {
    setMyPcNew({ ...myPcNew, page: page, scrollTo: undefined });
  };
  const updateSort = (col, order) => {
    setMyPcNew({
      ...myPcNew,
      sortColumn: capitalizeFirstLetter(col),
      sortOrder: order,
      sorted: true,
    });
  };

  useEffect(() => {
    if (
      myPcNew.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getSupplierProductsByID(props.SupplierID, myPcNew, (supplierProducts) => {
      setSupplierProductRes(supplierProducts);
    });
  }, [props.SupplierID, myPcNew]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/supplierProducts/addSupplierProduct", {
      state: {
        myPcNew: myPcNew,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "productID",
      width: 90,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
      // sortable: false,
    },
    {
      field: "productName",
      width: 350,
      align: "center",
      headerName: "نام محصول",
      headerAlign: "center",
      // sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.productID,
                id: cellValues.row.id,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addProduct",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setAddProduct(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Dialog
      PaperProps={
        {
          // elevation: 1,
        }
      }
      sx={{ zIndex: 200 }}
      fullWidth
      maxWidth={!addProduct ? "md" : "sm"}
      open={props.showProducts}
      onClose={() => props.setShowProducts(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ p: 1, px: 2 }}
        color="secondary"
        id="alert-dialog-title"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!addProduct ? (
            <Typography color="secondary" variant="subtitle1">
              لیست محصولات
            </Typography>
          ) : (
            <Typography variant="subtitle1">محصول را انتخاب کنید</Typography>
          )}
          {!addProduct ? (
            <IconButton
              onClick={() => {
                props.setShowProducts(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => {
                setAddProduct(false);
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {!addProduct ? (
          <Box sx={{ height: "30rem" }}>
            {supplierProductRes ? (
              <DataGrid
                disableVirtualization
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                pageSize={supplierProductRes.pageCondition.pageCount}
                rows={supplierProductRes.items}
                paginationMode="server"
                page={supplierProductRes.pageCondition.page - 1}
                onPageChange={(page) => {
                  updatePage(page + 1);
                }}
                rowCount={supplierProductRes.pageCondition.totalItemCount}
                enableRangeSelection={true}
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    scrollTo: myPcNew.scrollTo,
                    newFunc: newFunc,
                    nofab: true,
                    rowCount: supplierProductRes.pageCondition.totalItemCount,
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: deCapitalizeFirstLetter(myPcNew.sortColumn),
                        sort: deCapitalizeFirstLetter(myPcNew.sortOrder),
                      },
                    ],
                  },
                  pagination: {
                    page: myPcNew.page,
                  },
                }}
                onSortModelChange={(model) => {
                  updateSort(
                    model[0].field,
                    model[0].sort == "asc" ? "asc" : "desc"
                  );
                }}
                sortingOrder={["desc", "asc"]}
                sortingMode="server"
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              mt: 1,
            }}
          >
            <SearchComOff
              codeProduct
              productID={stateAdd.productID}
              productModel={stateAdd}
              setProductModel={setStateAdd}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateAdd.productID) {
                    enqueueSnackbar("محصول را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  addSupplierProduct(stateAdd, () => {
                    setProgress(true);
                    props.callback(props.SupplierID);

                    getSupplierProductsByID(
                      stateAdd.supplierID,
                      myPcNew,
                      (callback) => {
                        setSupplierProductRes(callback);
                      }
                    );
                    setAddProduct(false);
                    setStateAdd({ ...stateAdd, productID: "" });
                  });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    if (!stateAdd.productID) {
                      enqueueSnackbar("محصول را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    addSupplierProduct(stateAdd, () => {
                      setProgress(true);
                      props.callback(props.SupplierID);
                      getSupplierProductsByID(
                        stateAdd.supplierID,
                        myPcNew,
                        (callback) => {
                          setSupplierProductRes(callback);
                        }
                      );
                      setAddProduct(false);
                      setStateAdd({ ...stateAdd, productID: "" });
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => props.setShowProducts(false)}
                color="secondary"
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"محصول"}
          callback={() => {
            setProgress(true);
            deleteSupplierProduct(deleteState.id, () => {
              props.callback(props.SupplierID);

              getSupplierProductsByID(props.SupplierID, myPcNew, (callback) => {
                setSupplierProductRes(callback);
              });
            });
          }}
        ></DeleteRow>
      </DialogContent>
    </Dialog>
  );
}
